var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":"课堂管理","type":"0","route":"/homeIndex"}}),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('router-link',{key:index,staticClass:"course-item",attrs:{"to":item.path}},[_c('p',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('i')])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0857b1c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/live/courseManage.vue
// module id = null
// module chunks = 